// STAGING MEMBER ENTRY 2026-10-20 — the Partner modal's "Create a business account" door on staging.
// The export carries the production marketing address (https://snowgroup.ca/vendors/?src=snowbus, STORE-ENTRY-LINKS-20261018). On staging
// that sent testers to the live marketing page. On a staging build (NEXT_PUBLIC_VENDORS_URL on a `.stg.` host) the door is the staging
// vendors app's own Add-your-business page, the same destination ssoDoors() hands the sign-in page; the vendors middleware and the shared
// issuer carry sign-in/SSO from there. Any other build keeps the exported address untouched, so production routing does not move.

import { Env } from "@/libs/Env";

const ADD_BUSINESS_PATH = "/en/add-business";

/** The staging vendors Add-your-business URL, or null when this build is not a staging build with a vendors origin. */
export function stagingVendorsDoor(vendorsUrl: string | null | undefined): string | null {
  if (typeof vendorsUrl !== "string" || vendorsUrl === "") return null;
  try {
    const u = new URL(vendorsUrl);
    if ((u.protocol !== "https:" && u.protocol !== "http:") || !u.hostname.split(".").includes("stg")) return null;
    return `${u.origin}${ADD_BUSINESS_PATH}`;
  } catch {
    return null;
  }
}

/** This build's staging door, from the validated app env (NEXT_PUBLIC_VENDORS_URL, inlined by Next). */
export const STAGING_VENDORS_DOOR = stagingVendorsDoor(Env.NEXT_PUBLIC_VENDORS_URL);

interface DoorNode {
  p?: [string, string][];
  c?: DoorNode[];
}

/** Points every `data-sg-door="vendors"` anchor at `door`. Mutates the (already cloned) AST it is given. */
export function applyVendorsDoor<T extends DoorNode>(ast: T[], door: string | null): T[] {
  if (!door) return ast;
  const walk = (nodes: DoorNode[]) => {
    for (const n of nodes) {
      if (n.p?.some(([k, v]) => k === "data-sg-door" && v === "vendors")) {
        for (const pair of n.p) if (pair[0] === "href") pair[1] = door;
      }
      if (n.c) walk(n.c);
    }
  };
  walk(ast);
  return ast;
}
